import { Config } from '@backstage/config';

export const getAdditionalScopesFromConfig = (config: Config) => {
  const azureConfig = config.getOptionalConfig('scaffolder.providers.azure');
  if (!azureConfig) return [];
  if (!azureConfig.getOptionalBoolean('enabled')) return [];
  return azureConfig.getOptionalStringArray('additionalScopes') ?? [];
};
